export function toSentenceCase(text: string | undefined) {
  if (!text) return;

  return text
    .toLowerCase()
    .replace(/(?<=\b)[a-z]/, (s) => s.toUpperCase())
    .replace(/(?<=\s-\s)[a-z]/, (s) => s.toUpperCase());
}
